import * as React from 'react';

const Redirect24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.75 19.5c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h2.5a.75.75 0 0 0 0-1.5h-2.5A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25zm5.25-6a.75.75 0 0 0 1.06-.029l7.44-7.839V9A.75.75 0 0 0 21 9V3.75a.75.75 0 0 0-.75-.75H15a.75.75 0 0 0 0 1.5h3.506l-7.535 7.94A.75.75 0 0 0 11 13.5"
  }
));
Redirect24.Size = 24;
Redirect24.Title = "Redirect";

export { Redirect24 as default };
